import { Form } from 'react-bootstrap';

type Props = {
  selectedValue?: string | null;
  defaultValue?: string | null;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
};

const ScheduleScheduleStatus = ({ selectedValue, defaultValue = 'open', onChange }: Props) => {
  const value = selectedValue ?? defaultValue ?? '';

  return (
    <Form.Group className="mb-2" controlId="formScheduleScheduleStatus">
      <Form.Label>Schedule Window Status</Form.Label>
      <Form.Select aria-label="schedule-scheduling-window-status-select" name="schedule_scheduling_window_status" value={value} onChange={onChange}>
        <option value="open">Open</option>
        <option value="closed">Closed</option>
      </Form.Select>
    </Form.Group>
  );
};

export default ScheduleScheduleStatus;
